<script lang="ts">
  import Rendering from "@component/factory.svelte";
  interface Props {
    name: string | undefined;
    route: { [key: string]: any };
  }

  let { name, route }: Props = $props();
</script>

{#if name && route?.placeholder && !!route.placeholder[name]}
  {#each route?.placeholder[name] as rendering}
    <Rendering {rendering} />
  {/each}
{/if}
